import React from 'react';
import styled from 'styled-components/native';
import TextBox from '../TextBox';
import ListItemButton from '../ListItemButton';
import colors from '../../constants/colors';
import {ParameterWithNextFragment} from '../../graphql-types';

import CheckedIcon from '../../assets/images/checkbox-checked.png';
import UncheckedIcon from '../../assets/images/checkbox-unchecked.png';

// Parameters whose non-"none" answers ask the user to verify their response
// before continuing. Keyed by parameter id or slug (slug is derived from the
// parameter name since the GraphQL schema does not expose a slug field).
const CONFIRMATION_PROMPTS: {[key: string]: string} = {
  'respiratory-irritation':
    'You reported respiratory irritation. Are you sure your response is correct?',
  'dead-fish':
    'You reported dead fish. Are you sure your response is correct?',
};

const slugify = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getConfirmationPrompt = (
  parameter: ParameterWithNextFragment,
): string | undefined =>
  CONFIRMATION_PROMPTS[parameter.id] ??
  CONFIRMATION_PROMPTS[slugify(parameter.name)];

export const isNoneValue = (value: {
  name?: string | null;
  value?: string | null;
}): boolean =>
  (value.value ?? '').trim().toLowerCase() === 'none' ||
  (value.name ?? '').trim().toLowerCase() === 'none';

const Prompt = styled(TextBox)`
  padding-top: 20px;
  font-size: 18px;
  margin-bottom: 1px;
  background: ${colors.app.white};
`;

type ConfirmationProps = {
  prompt: string;
  confirmed: boolean | null;
  onConfirm: (confirmed: boolean) => void;
};

export default function Confirmation({
  prompt,
  confirmed,
  onConfirm,
}: ConfirmationProps) {
  return (
    <>
      <Prompt bold={true}>{prompt}</Prompt>
      <ListItemButton
        title="Yes, my response is correct"
        icon={confirmed === true ? CheckedIcon : UncheckedIcon}
        onPress={() => onConfirm(true)}
      />
      <ListItemButton
        title="No, let me change my response"
        icon={confirmed === false ? CheckedIcon : UncheckedIcon}
        onPress={() => onConfirm(false)}
      />
    </>
  );
}
